module.exports = __webpack_public_path__ + "img/icon-protrain-1.a055672a.png";